import React from 'react';

import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';

import { DROPZONE_SIZES, Size, sizePropType } from '../consts';

type DefaultActiveDragContentProps = {
  size?: Size;
};

const DefaultActiveDragContent = React.forwardRef<
  HTMLDivElement,
  DefaultActiveDragContentProps
>(({ size }, ref) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <div
      ref={ref}
      css={[
        size === DROPZONE_SIZES.SMALL
          ? theme.typography.heading3
          : theme.typography.heading2,
      ]}
    >
      {T.translate('DROP_FILES_TO_UPLOAD')}
    </div>
  );
});

DefaultActiveDragContent.displayName = 'DefaultActiveDragContent';

DefaultActiveDragContent.propTypes = {
  /** Dropzone size */
  size: sizePropType,
};

export default DefaultActiveDragContent;
